import { inject, observer } from 'mobx-react';
import React from 'react';
import DatePicker from 'react-datepicker';
import { format, isValid, toDate } from "date-fns";
import moment from 'moment';
import ReleaseIncidentDataStore from '../store/release-incident-store';
@inject('ReleaseIncidentDataStore')
@observer
class LeakDetectionTimeComponent extends React.Component {
  constructor(props) {
    super(props);
    var d = this.props.ReleaseIncidentDataStore.dateSelection.leakDetectionTime!='' && this.props.ReleaseIncidentDataStore.dateSelection.leakDetectionTime!=null?moment(this.props.ReleaseIncidentDataStore.dateSelection.leakDetectionTime):'';
    this.state = {
        leakDetectionTime: typeof this.props.ReleaseIncidentDataStore.dateSelection.leakDetectionTime!='undefined' && this.props.ReleaseIncidentDataStore.dateSelection.leakDetectionTime!='' && this.props.ReleaseIncidentDataStore.dateSelection.leakDetectionTime!==null && d.isValid()?(moment(this.props.ReleaseIncidentDataStore.dateSelection.leakDetectionTime).toDate()):''
    }
  }

  handleLeakDetectionTimeChange = async(estimes) => {
    let estime = estimes!='' && typeof estimes!='undefined' && estimes!=null?moment(estimes).toDate():'';
    await ReleaseIncidentDataStore.leakDetectionTimeUpdate(estime);

    this.setState(state => ({
        leakDetectionTime: (estime!='' && typeof estime!='undefined' && estime!==null?estime:''),
    }))
  }

  render() {
    var {dateSelection} = this.props.ReleaseIncidentDataStore;
    
    return(
      <div>
          <DatePicker
              className='form-control'
              selected={this.state.leakDetectionTime!='' && typeof this.state.leakDetectionTime!='undefined' && this.state.leakDetectionTime!==null?this.state.leakDetectionTime:''}
              value={this.state.leakDetectionTime!='' && typeof this.state.leakDetectionTime!='undefined' && this.state.leakDetectionTime!==null?this.state.leakDetectionTime:''}
              shouldCloseOnSelect={false}
              onChange={(etime)=>this.handleLeakDetectionTimeChange(etime)}
              showTimeInput
              timeInputLabel="Time:"
              dateFormat="MM-dd-yyy HH:mm"
              readOnly={this.props.isDisabled?true:false}
              //timeFormat="HH:mm"
          />
          {((this.props.submitInfo==2 || this.props.submitInfo==3) && this.state.leakDetectionTime=='' ) && <span className="error_form">Required</span>}
      </div>
    )
  }
}

export default LeakDetectionTimeComponent;